<!-- pricing.component.html -->

<!-- HEADER -->
<section class="bg-white text-center py-16">
  <div class="max-w-5xl mx-auto px-6 space-y-4">
    <p class="text-xs tracking-widest text-blue-600 font-semibold">
      SIMPLE & CLEAR PRICING
    </p>

    <h1 class="text-3xl md:text-4xl font-bold leading-snug text-gray-900">
      Pricing that supports your compliance goals
    </h1>

    <p class="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
      Practical ISO 27001 and ISO 42001 services designed to help Organisations achieve certification readiness efficiently.
    </p>
  </div>
</section>

<!-- PRICING CARDS -->
<section class="bg-gray-50 py-12">
  <div class="max-w-7xl mx-auto px-6 grid gap-8 grid-cols-1 md:grid-cols-3">

    @for (plan of pricingPlans; track plan) {
      <div
        class="bg-white rounded-xl shadow-lg p-6 border border-gray-200 flex flex-col h-full"
      >
        <!-- Title -->
        <h2 class="text-xl font-bold text-gray-800 mb-3">
          {{ plan.title }}
        </h2>

        <!-- Price -->
        <p class="text-3xl md:text-4xl font-extrabold text-blue-600 mb-1">
          {{ plan.price }}
        </p>

        <!-- Optional note -->
        @if (plan.note) {
          <p class="text-xs text-gray-400 italic mb-4">
            {{ plan.note }}
          </p>
        }

        <!-- Features -->
        <ul class="space-y-1.5 text-gray-700 mb-5">
          @for (feature of plan.features; track feature) {
            <li class="flex items-start gap-2 text-sm">
              <span class="text-blue-600 mt-1 text-sm leading-none">•</span>
              <span class="leading-relaxed text-sm">
                {{ feature }}
              </span>
            </li>
          }
        </ul>

        <!-- CTA -->
        <div class="mt-auto">
          <button
            (click)="navigate(plan)"
            class="bg-blue-600 text-white w-full py-2.5 rounded-lg font-semibold hover:bg-blue-700 transition text-sm"
          >
            {{ plan.cta }}
          </button>
        </div>
      </div>
    }

  </div>

  <!-- ✅ GLOBAL DISCLAIMER -->
  <div class="max-w-5xl mx-auto px-6 mt-10 text-center">
    <p class="text-xs text-gray-500">
      * Flexible pricing based on your organisation’s size and scope.
    </p>
  </div>
</section>